export const STEPPER_PAGE_MAX_WIDTH = 1334;
